import Svg, { SvgProps, Path } from 'react-native-svg';

const RightIcon = (props: SvgProps) => (
  <Svg viewBox="0 0 30 30" width={30} height={30} fill="#FFFFFF" {...props}>
    <Path d="M22 15a.997.997 0 0 1-.293.707l-10 10A1 1 0 0 1 10 25V5a.999.999 0 0 1 1.707-.707l10 10A.997.997 0 0 1 22 15z" />
  </Svg>
);

export default RightIcon;
